/* eslint-disable complexity */
import { stickers_sets } from "@/components/chat/utils/stickers-config";
import Quill from "quill";
const Delta = Quill.import("delta");

export async function handleDealPasteData(data: any) {
  let { range, text, html, doc, _this, quillJson } = data;
  text = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  let delta = new Delta().retain(range.index);
  let scrollTop = _this.quill.scrollingContainer.scrollTop;
  _this.container.focus();
  _this.quill.selection.update("silent");
  let isQuill = false;
  setTimeout(() => {
    // if (newFile !== undefined) return;
    if (
      html &&
      !doc.querySelector("body") &&
      doc.querySelectorAll(".message-box-container").length === 0 &&
      doc.querySelectorAll("p").length > 0 &&
      doc.querySelectorAll(".message-node").length === 0
    ) {
      delta = delta.concat(_this.convert(html)).delete(range.length);
    } else if(quillJson) {
      isQuill = true;
      const quillArr = JSON.parse(quillJson);
      if (quillArr?.length &&
        quillArr[quillArr.length - 1].insert === "\n" &&
        !quillArr[quillArr.length - 1]?.attributes
      ) {
        quillArr.pop();
      }
      delta = delta.concat({ ops: quillArr }).delete(range.length);
    } else if (!html && text) {
      delta = delta.insert(text).delete(range.length);
    } else if (text) {
      text = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      const patt = /\[.*?\]/g;
      const re = text.match(patt);
      let result = text;
      if (re && re.length > 0) {
        const reSet = new Set([...re]);
        reSet.forEach((r: string) => {
          if (!r) {
            return;
          }
          if (!stickers_sets[r]) {
            return;
          }
          let tmpIndex = r.indexOf("]");
          let tmpStr = r.substring(1, tmpIndex);
          let regexp = new RegExp(`\\[${tmpStr}\\]`, "g");
          // result = result.replace(/[\r\n]/g,"");
          result = result.replace(
            regexp,
            `<span class="e-emoji" contenteditable="false" data-value="${r}">&#65279;<span contenteditable="false">${r}</span>&#65279;</span>`
          );
        });
      }
      const pattern1 = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
      const specialEmojiRegex = /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;

      let rtnResult = "";
      for (const temp of result) {
        if (pattern1.test(temp) && stickers_sets[temp]) {
          rtnResult += `<span class="e-emoji" contenteditable="false" data-value="${temp}">&#65279;<span contenteditable="false">${temp}</span>&#65279;</span>`;
        } else {
          if (
            (specialEmojiRegex.test(temp) && stickers_sets[temp]) ||
            specialEmojiRegex.test(temp)
          ) {
            rtnResult += `<span class="e-emoji" contenteditable="false" data-value="${temp}">&#65279;<span contenteditable="false">${temp}</span>&#65279;</span>`;
          } else {
            rtnResult += temp;
          }
        }
      }
      const t1 = /<\/p><p style/g;
      const content = t1.test(html)
        ? rtnResult.replace(/(\n){2}|(\r\n){2}/g, "<br/>")
        : rtnResult.replace(/(\n)|(\r\n)/g, "<br/>");
      const p = `<p>${content}</p>`;
      delta = delta.concat(_this.convert(p)).delete(range.length);
    } else {
      delta = delta.concat(_this.convert(html)).delete(range.length);
    }

    let result = new Delta().retain(range.index);
    if (isQuill) {
      result = delta;
    } else {
      delta.forEach((op: any) => {
        if (
          op.insert &&
          ((typeof op.insert === "string" && op.insert.trim()) ||
            op.insert["mention-link"] ||
            op.insert["custom-emoji"])
        ) {
          result.ops.push({ insert: op.insert });
        }
      });
      result = result.delete(range.length);
    }
    _this.quill.updateContents(result, "user");
    // range.length contributes to delta.length()
    _this.quill.setSelection(result.length() - range.length, "user");
    _this.quill.scrollingContainer.scrollTop = scrollTop;
    _this.quill.focus();
  });
}
